import {
  IStudentEarlyAlert,
  IStudentEarlyAlerts,
} from "../../../../models/student/studentGrades";
import { baseURL } from "../../../../constants/commonConstants";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { setStudentEarlyAlerts } from "../../../../store/slices/student/studentEarlyAlertsSlice";
import { getStudentEarlyAlertsDetails } from "../../../../action/student/studentEarlyAlertsActionCreator";
import { getCurrentUserData } from "../../../../action/user/userProfileActionCreator";
import { limit } from "../../../../constants/pageBlocks";

const EarlyAlerts = (props: IStudentEarlyAlert) => {
  const { getStudentEarlyAlerts, earlyAlerts, userInfo } = props;

  const dispatch = useDispatch();

  const convertDate = (dateString: string) => {
    const date = new Date(`1970-01-01T${dateString}Z`);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const roundedMinutes = Math.round(minutes / 10) * 10;
    date.setUTCMinutes(roundedMinutes);
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    if (hours === 0) hours = 12;
    const formattedMinutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${hours}:${formattedMinutes} ${period}`;
  };

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getStudentEarlyAlerts(userInfo?.id, limit.four);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setStudentEarlyAlerts([]));
    };
  }, []);

  return (
    <>
      <div className="card-wrap">
        <div className="title">
          <h2>Early Alerts</h2>
          <a
            href="https://www.w3schools.com/"
            className="btn-link"
            target="_blank"
          >
            View All
          </a>
        </div>
        <ul className="transactions-wrap earlyalerts mt-3 mb-0">
          {earlyAlerts?.map((alert: IStudentEarlyAlerts) => (
            <li className="pe-none" key={alert.id}>
              <div className="img img-orange">
                <img src={alert.image} alt="" />
              </div>
              <div className="w-100">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h6 className="m-0 para-hide-2">{alert.name}</h6>
                  <p className="date">{convertDate(alert.time)}</p>
                </div>
                <p className="h-40 para-hide-2">{alert.message}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentEarlyAlerts: (id: string, count: number) =>
    getStudentEarlyAlertsDetails(id, count),
};

function mapStateToProps(state: any) {
  return {
    earlyAlerts: state.studentEarlyAlerts.earlyAlerts,
    userInfo: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EarlyAlerts);
